module.exports = __webpack_public_path__ + "static/media/track-cell-zero.414e4829.png";